export const TRANSACTION_SOURCE_DEF_GET = "/TransactionSourceDef/GetAllTransactionSourceDef"